import slider from "./modules/slider";
import marquee from "./modules/marquee";
import parallax from "./modules/parallax";
import anim from "./modules/anim";
import nav from "./modules/nav";
import anchors from "./modules/anchors";
import forms from "./modules/forms";
import lang from "./modules/lang";
import backBtn from "./modules/backBtn";
import popup from "./modules/popup";
import cart from "./modules/cart";
import filter from "./modules/filter";

document.addEventListener("DOMContentLoaded", () => {
  function startJs() {
    nav();
    anim();
    slider();
    marquee();
    parallax();
    anchors();
    forms();
    lang();
    backBtn();
    popup();
    cart();
    filter();
  }

  const preloader = document.querySelector(".preloader");

  if (preloader) {
    document.body.style.overflow = "hidden";

    setTimeout(() => {
      document.body.style.overflowY = "initial";
      document.body.style.overflowX = "hidden";
      preloader.classList.add("hide");

      setTimeout(() => {
        startJs();
      }, 600);
    }, 3000);
  } else {
    startJs();
  }
});
